import * as React from 'react';
import classnames from 'classnames';

export interface IconProps {
	type?: 'fa';
	icon?: keyof IconDictionary;
	size?: '1' | '2' | '3' | '4' | '5';
	color?: string;
	spin?: boolean;
}

interface IconDictionary {
	message: string;
	key: string;
	user: string;
	signIn: string;
	warning: string;
	gear: string;
	question: string;
	lock: string;
	clock: string;
	uncheck: string;
	check: string;
	review: string;
	angleDown: string;
	caretDown: string;
}
const faIconRegister: IconDictionary = {
	message: 'fa-envelope',
	user: 'fa-user',
	key: 'fa-key',
	signIn: 'fa-sign-in',
	warning: 'fa-warning',
	gear: 'fa-gear',
	question: 'fa-question-circle-o',
	lock: 'fa-lock',
	clock: 'fa-clock-o',
	uncheck: 'fa-square-o',
	check: 'fa-check-square-o',
	review: 'fa-eye',
	angleDown: 'fa-angle-down',
	caretDown: 'fa-caret-down',
};

const Icon: React.FC<IconProps> = props => {
	return (
		<i
			className={classnames(iconTypeFactory(props.type, props.size, props.spin), iconFactory(props.type, props.icon))}
			style={{ color: props.color }}
		/>
	);
};

Icon.defaultProps = {
	icon: null,
	size: '1',
	type: 'fa',
};

function iconTypeFactory(type: IconProps['type'], size = '1', spin = false) {
	switch (type) {
		case 'fa':
			var typeClass = 'fa';
			var fa_size = 'fa-fw fa-' + (size === '1' ? 'lg' : size + 'x');
			var spinClass = spin ? 'fa-spin' : null;
			return classnames(typeClass, fa_size, spinClass);
		default:
			return null;
	}
}
function iconFactory(type: IconProps['type'], icon: keyof IconDictionary) {
	switch (type) {
		case 'fa':
			return faIconRegister[icon] || null;
		default:
			return null;
	}
}
export default Icon;
